require('./helpers/bundle-manifest').register(JSON.parse("{\"d3X8m\":\"index.e836c988.js\",\"icTbU\":\"logo.07444c7c.svg\",\"8upuA\":\"index.d0f2ad04.css\"}"));